export default class StaticInfoTab
{
  constructor(titles, contents) 
  {
    this.titles = titles; // {} instead of array to support stringify
    this.contents = contents; // {} instead of array to support stringify
  }    

  isValid()
  {
    var result = true;

    // Titles
    for (const [key, value] of Object.entries(this.titles)) {
      if(!value)
      {
        result = false;
        break;
      }
    }

    // Contents
    for (const [key, value] of Object.entries(this.contents)) {
      if(!value)
      {
        result = false;
        break;
      }
    }

    return result;
  }
}